import { useEffect } from 'react';
import Teams from '../../components/teams';
import { TemasBanner, TeamMember } from '../../assets/images';
import ImageBanner from '../../components/imageBanner';

const contactDataLeft = [
    {
        image: TeamMember,
        title: 'New Accounts and Sales Enquiries',
        mail: 'sales@primedirectdist.co.uk',
    },
    
    {
        image: TeamMember,
        title: 'Label and General Enquiries',
        mail: 'info@primedirectdist.co.uk',
    },
    
    {
        image: TeamMember,
        title: 'Digital Enquiries',
        mail: 'russell@primedirectdist.co.uk',
    },
    
    {
        image: TeamMember,
        title: 'Logistics / Warehouse',
        mail: 'warehouse@primedirectdist.co.uk',
    }
    
   
    

];

const contactDataMiddle = [
    
    {
        image: TeamMember,
        title: 'Spencer Broughton',
        category: 'Director',
        mail: 'spencer@primedirectdist.co.uk',
    },
    
   
    {
        image: TeamMember,
        title: 'Richard Stewart',
        category: 'Director',
        mail: 'richard@primedirectdist.co.uk',
    },
    
    
    {
        image: TeamMember,
        title: 'Karen Howarth',
        category: 'Office Manager',
        mail: 'karen@primedirectdist.co.uk',
    },
   
    {
        image: TeamMember,
        title: 'David James',
        category: 'Head of Production / Label Manager',
        mail: 'davidj@primedirectdist.co.uk',
    },
    
    {
        image: TeamMember,
        title: 'Claire Draper',
        category: 'Accounts',
        mail: 'claire@primedirectdist.co.uk',
    },
    {
        image: TeamMember,
        title: 'Andy Colver',
        category: 'General Manager',
        mail: 'andy@primedirectdist.co.uk',
    },
    // {
    //     image: TeamMember,
    //     title: 'Josh Hockney',
    //     category: 'Digital Marketing / Social Media Manager',
    //     mail: 'josh@primedirectdist.co.uk',
    // },
    


];

const contactDataRight = [
   
    {
        image: TeamMember,
        title: 'Lee Elliston',
        category: 'Head of International Sales',
        mail: 'lee@primedirectdist.co.uk',
    },
   
    // {
    //     image: TeamMember,
    //     title: 'Jay Le Vack',
    //     category: 'Sales Manager',
    //     mail: 'jay@primedirectdist.co.uk',
    // },
    
    {
        image: TeamMember,
        title: 'Russell Pollitt',
        category: 'Head of Digital',
        mail: 'russell@primedirectdist.co.uk',
    },
  
    {
        image: TeamMember,
        title: 'Matthew Range',
        category: 'Warehouse Manager / Logistics',
        mail: 'matt@primedirectdist.co.uk',
    },
   
   
    
    {
        image: TeamMember,
        title: 'Stuart Clark',
        category: 'Head of Label Management',
        mail: 'stu@primedirectdist.co.uk',
    },
   

    {
        image: TeamMember,
        title: 'Jack Doherty',
        category: 'Software Developer',
        mail: 'jack@primedirectdist.co.uk',
    },

    {
        image: TeamMember,
        title: 'Miche Davies',
        category: 'Head of Global Licencing',
        mail: 'miche@primedirectdist.co.uk',
    },
    {
        image: TeamMember,
        title: 'Rocky Lee',
        category: 'Production Assistant',
        mail: 'rocky@primedirectdist.co.uk',
    }

];
const Team = () => {

    useEffect(() => {
        // document.title = 'Contacts - Prime Direct Distribution';
    }, [])

    return (
        <div className="team">
            {/* <ImageBanner image={TemasBanner} /> */}

            <Teams conatctDescLeft={contactDataLeft} conatctDescMiddle={contactDataMiddle} conatctDescRight={contactDataRight}/>
        </div>
    )
}

export default Team;